import domReady from '@wordpress/dom-ready';

domReady(() => {
  const categorizedAccordionBlocks = document.querySelectorAll(
    '.block-categorized-accordions'
  );

  if (categorizedAccordionBlocks.length > 0) {
    categorizedAccordionBlocks.forEach((block) => {
      initializeCategorizedAccordions(block);
    });
  }
});

function initializeCategorizedAccordions(block) {
  const categoryButtons = block.querySelectorAll('.category-item');
  const accordionGroupsContainer = block.querySelector(
    '.accordion-groups-container'
  );
  const accordionGroups = accordionGroupsContainer
    ? accordionGroupsContainer.querySelectorAll('.block-accordions-group')
    : [];

  // Initially hide all accordion groups except those for the first category
  accordionGroups.forEach((group, index) => {
    if (index === 0) {
      group.style.display = 'block';
      group.classList.add('active');
    } else {
      group.style.display = 'none';
      group.classList.remove('active');
    }
  });

  // Handle category switching
  categoryButtons.forEach((button, categoryIndex) => {
    button.addEventListener('click', () => {
      switchCategory(categoryIndex, categoryButtons, accordionGroups);
    });
  });
}

function switchCategory(activeIndex, categoryButtons, accordionGroups) {
  // Update active category button
  categoryButtons.forEach((button, index) => {
    if (index === activeIndex) {
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
    } else {
      button.classList.remove('active');
      button.setAttribute('aria-selected', 'false');
    }
  });

  // Show/hide accordion groups
  // Each accordion group corresponds to a category by index
  accordionGroups.forEach((group, index) => {
    if (index === activeIndex) {
      group.style.display = 'block';
      group.classList.add('active');
      group.setAttribute('aria-hidden', 'false');
    } else {
      group.style.display = 'none';
      group.classList.remove('active');
      group.setAttribute('aria-hidden', 'true');
    }
  });
}
